import React from 'react'
import { StyledOnlineBadge, StyledOfflineBadge } from '../../styles'
import * as PropTypes from 'prop-types'

const CheckOnlineOffline = (props) => {
  const {
    online,
    children,
    className,
    style,
    onlineClass,
    offlineClass,
    ...rest
  } = props
  return online ? (
    <StyledOnlineBadge
      overlap="circle"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      variant="dot"
      className={onlineClass}
      style={style}
      {...rest}>
      {children}
    </StyledOnlineBadge>
  ) : (
    <StyledOfflineBadge
      overlap="circle"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      variant="dot"
      className={offlineClass}
      style={style}
      {...rest}>
      {children}
    </StyledOfflineBadge>
  )
}

CheckOnlineOffline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  online: PropTypes.bool,
  classes: PropTypes.string
}

CheckOnlineOffline.displayName = 'coo'

export default CheckOnlineOffline
